{
  "name": "ui-thing",
  "version": "0.2.6",
  "description": "CLI used to add Nuxt components to a project",
  "keywords": [
    "cli",
    "ui",
    "thing",
    "nuxt",
    "reka-ui",
    "tailwindcss",
    "nuxtui",
    "shadcn-ui"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/BayBreezy/ui-thing-cli.git"
  },
  "license": "MIT",
  "author": {
    "name": "Behon Baker",
    "email": "behon.baker@yahoo.com",
    "url": "https://behonbaker.com/"
  },
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "bin": {
    "ui-thing": "dist/index.js"
  },
  "scripts": {
    "build": "tsup",
    "clean": "rm -rf dist coverage node_modules package-lock.json && npm install",
    "coverage": "vitest run --coverage",
    "dev": "tsup --watch",
    "format": "npx prettier --write .",
    "knip": "knip",
    "knip:fix": "knip --fix",
    "lint": "eslint src",
    "lint-staged": "lint-staged",
    "lint:fix": "eslint src --fix",
    "prepare": "husky",
    "release": "npm run build && npx changelogen@latest --release && npm publish && git push --follow-tags",
    "start": "node dist/index.js",
    "test": "vitest"
  },
  "lint-staged": {
    "*": [
      "npm run format"
    ]
  },
  "dependencies": {
    "axios": "^1.13.2",
    "boxen": "^8.0.1",
    "c12": "^3.3.3",
    "commander": "^14.0.2",
    "consola": "^3.4.2",
    "dotenv": "^17.2.3",
    "es-toolkit": "^1.43.0",
    "execa": "^9.6.1",
    "figlet": "^1.9.4",
    "fs-extra": "^11.3.3",
    "kleur": "^4.1.5",
    "lodash": "^4.17.21",
    "magicast": "^0.5.1",
    "ora": "^9.0.0",
    "prompts": "^2.4.2"
  },
  "devDependencies": {
    "@eslint/js": "^9.39.2",
    "@ianvs/prettier-plugin-sort-imports": "^4.7.0",
    "@types/fs-extra": "^11.0.4",
    "@types/lodash": "^4.17.21",
    "@types/node": "^24.10.4",
    "@types/prompts": "^2.4.9",
    "@vitest/coverage-v8": "^4.0.16",
    "@vitest/ui": "^4.0.16",
    "axios-mock-adapter": "^2.1.0",
    "eslint": "^9.39.2",
    "globals": "^16.5.0",
    "husky": "^9.1.7",
    "jiti": "^2.6.1",
    "knip": "^5.78.0",
    "lint-staged": "^16.2.7",
    "prettier": "^3.7.4",
    "tsup": "^8.5.1",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.51.0",
    "vitest": "^4.0.16"
  },
  "publishConfig": {
    "access": "public"
  }
}
